import React from "react";
import { Col } from "ComponentsUI/Styles/Grid";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import withStyles from "react-jss";
import classNames from "classnames";

const styles = (theme) => ({
	root: {
		backgroundColor: theme.palette.colors.transparent,
		paddingBottom: "10px",
	},
	wrapper: {
		paddingBottom: "10px",
	},
	headerWrapper: {
		display: "flex",
		alignItems: "flex-start",
	},
	headerText: {
		fontFamily: theme.fonts.bold,
		fontSize: "16px",
		lineHeight: 2,
		letterSpacing: "2px",
		color: theme.palette.colors.darkSlateBlue,
		margin: 0,
		padding: 0,
		position: "relative",
		marginLeft: "31px",
	},
	homeOrder: {
		marginLeft: "15%",
	},
	withoutSpacing: {
		padding: "0",
		"& $wrapper": {
			padding: "0",
		},
		"& $headerText": {
			margin: "0",
		},
		"& .row": {
			margin: "0",
		},
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		headerText: {
			"&:after": {
				width: "58px",
			},
		},
		homeOrder: {
			marginLeft: "11%",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		headerText: {
			fontSize: "16px",
			lineHeight: 2.25,
			letterSpacing: "1.8px",
			marginLeft: "21px",
			"&:after": {
				width: "48px",
				bottom: "-8px",
			},
		},
		homeOrder: {
			marginLeft: 0,
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		headerText: {
			fontSize: "16px",
			lineHeight: 1,
			marginLeft: 0,
			"&:after": {
				display: "none",
			},
		},
		homeOrder: {
			marginLeft: 0,
		},
	},
});

class TariffsActualDate extends React.PureComponent {
	render() {
		let classes = this.props.classes;
		return (
			<div
				className={classNames(classes.root, {
					[classes.homeOrder]: this.props.homeOrder,
					[classes.withoutSpacing]: this.props.withoutSpacing,
				})}
			>
				{this.props.date && (
					<Row>
						<Col xs={12} className={classes.wrapper}>
							<div className={classes.headerWrapper}>
								<div className={classes.headerText}>
									{`Актуальность: ${this.props.date}`}
									<meta itemProp="priceValidUntil" content={this.props.date} />
								</div>
							</div>
						</Col>
					</Row>
				)}
			</div>
		);
	}
}

export default withStyles(styles)(TariffsActualDate);
